module.exports = __webpack_public_path__ + "static/media/card-on-delivery.f19748e5.svg";